import api from "app/api";
import { ROLES } from "app/constants";
import useAccess from "features/profile/useAccess";
import { useEffect, useState } from "react";

export default function useNotifyCount() {
  const [count, setCount] = useState(0);
  const { hasRoles } = useAccess();
  async function loadNotifyCount() {
    if (hasRoles(ROLES.PARTNER)) {
      return;
    }
    const { success, data, error } = await api.get("/bookings/notify-count");
    if (success) {
      setCount(data?.count || 0);
    }
  }

  useEffect(() => {
    loadNotifyCount();
  }, []);
  return count;
}
